import { useContext } from 'react';
import referralContext from './referralContext';
import { ReferralDataType, ReferralTypes } from './refferalTypes';

const useReferralState = (): ReferralTypes => {
    const context = useContext(referralContext);

    if (!Object.keys(context).length) {
        throw new Error('ReferralContext must be used within its provider');
    }

    const { dispatch } = context;

    const setReferral = (id: ReferralDataType) =>
        dispatch({ type: 'SET_REFERRAL', payload: id });

    return {
        ...context,
        setReferral,
    };
};

export default useReferralState;
